import React from 'react'
import { Checkbox } from 'antd'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import Tooltip from '../../common/Tooltip'
import { useStore } from '../../../store/store'

// Case « Optionnelle » : réglage du modèle, hérité par les propositions créées
// ensuite. Vide, la variable ne compte ni dans les valeurs manquantes ni dans
// le filigrane.
const OptionalVariableCheckbox = ({ checked, disabled, onChange }) => {
  const { t } = useTranslation()
  const isTemplate = useStore(({ currentDocument }) => currentDocument.type === 'template')
  if (!isTemplate) return null

  return (
    <Checkbox
      checked={!!checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      style={{ marginBottom: 16 }}
    >
      {t('optional-variable')}
      <Tooltip trigger="hover" placement='bottom' title={t('optional-variable-help')}>
        <FontAwesomeIcon
          icon={icon({ name: 'circle-info', style: 'solid' })}
          style={{ marginLeft: 6, color: '#0b2239' }}
        />
      </Tooltip>
    </Checkbox>
  )
}

// Même case pour une box variable : le flag vit sur la box.
export const OptionalBoxCheckbox = ({ box, updateBoxFn }) => {
  const storeUpdateBox = useStore(({ updateBox }) => updateBox)
  const updateBox = updateBoxFn ?? storeUpdateBox
  return (
    <OptionalVariableCheckbox
      checked={box.optional}
      disabled={box.from_linked_section}
      onChange={(checked) => updateBox(box.id, (b) => {
        b.optional = checked
      })}
    />
  )
}

export default OptionalVariableCheckbox
